<template lang="pug">
  article.product-listings-layout
    header.flex.flex-wrap
      //- (left column space)
      .hidden.lg-block.w-225.pl-34
      //- centered
      .flex-1
        .text-18.md-text-24.text-center
          slot(name="title")
        slot(name="description")

        //- sort row
        .w-full.mt-50.flex.justify-center.md-justify-end.md-pr-10vw(v-if="sortVisible")
          //- sort dropdown, outlined
          .relative.z-10.border-transp.hover-border-gray-300.text-13(:class="{'border-gray-300': sortOpen}", @mouseleave="sortOpen = false")
            //- toggle
            button.h-40.px-20.border.hover-border-blue.hover-text-blue.border-gray-300.focus-text-blue.active-text-blue.focus-border-blue.active-border-blue.md-border-inherit.flex.items-center.leading-none.pt-3.relative.z-10(@click="sortOpen = !sortOpen")
              | Sort By: {{ activeSort.label }}
              icon-chevron.ml-15.mb-4(:up="sortOpen")
            //- (list)
            ul.absolute.w-full.left-0.-mt-px.py-10.bg-gray-100.border.border-inherit(v-show="sortOpen")
              li(v-for="opt in sortOptions")
                button.btn-theme-text.w-full.text-left.whitespace-no-wrap.pr-12.pl-20.py-3(@click="setSort(opt.handle); sortOpen = false") {{opt.label}}

    section.flex.pt-50.items-start
      //- (left-col)
      .hidden.lg-block.w-225.pl-34.sticky-off.top-120
        slot(name="leftcol")

      //- products
      .flex-1
        slot

</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import IconChevron from '@/components/Icons/ChevronY'
export default {
  name: 'ProductListingsLayout',
  props: ['sortVisible'],
  data () {
    return {
      sortOpen: false
    }
  },
  computed: {
    ...mapGetters({ 'activeSort': 'shop/activeSort' }),
    ...mapState({
      sortOptions: state => state.shop.sortOptions
    })
  },
  methods: {
    ...mapMutations({ 'setSort': 'shop/setSort' })
  },
  components: { IconChevron }
}
</script>

<style>
</style>
